import React from 'react';

const COUNTRY_OPTIONS = [
  ["Germany","Deutschland"],
  ["Albania","Albanien"],
  ["Andorra","Andorra"],
  ["Armenia","Armenien"],
  ["Austria","Österreich"],
  ["Azerbaijan","Aserbaidschan"],
  ["Belarus","Weißrussland"],
  ["Belgium","Belgien"],
  ["Bosnia","Bosnien und Herzegowina"],
  ["Bulgaria","Bulgarien"],
  ["Croatia","Kroatien"],
  ["Cyprus","Zypern"],
  ["CzechRepublic","Tschechien"],
  ["Denmark","Dänemark"],
  ["Estonia","Estland"],
  ["Finland","Finnland"],
  ["France","Frankreich"],
  ["Georgia","Georgien"],
  ["Greece","Griechenland"],
  ["Hungary","Ungarn"],
  ["Iceland","Island"],
  ["Ireland","Irland"],
  ["Italy","Italien"],
  ["Kazakhstan","Kasachstan"],
  ["Kosovo","Kosovo"],
  ["Latvia","Lettland"],
  ["Liechtenstein","Liechtenstein"],
  ["Lithuania","Litauen"],
  ["Luxembourg","Luxemburg"],
  ["Malta","Malta"],
  ["Moldova","Moldawien"],
  ["Monaco","Monaco"],
  ["Montenegro","Montenegro"],
  ["Netherlands","Niederlande"],
  ["NorthMacedonia","Nordmazedonien"],
  ["Norway","Norwegen"],
  ["Poland","Polen"],
  ["Portugal","Portugal"],
  ["Romania","Rumänien"],
  ["Russia","Russland"],
  ["SanMarino","San Marino"],
  ["Serbia","Serbien"],
  ["Slovakia","Slowakei"],
  ["Slovenia","Slowenien"],
  ["Spain","Spanien"],
  ["Sweden","Schweden"],
  ["Switzerland","Schweiz"],
  ["Turkey","Türkei"],
  ["Ukraine","Ukraine"],
  ["United Kingdom","Vereinigtes Königreich"],
  ["United States","Vereinigte Staaten"],
];

export default function CountrySelect({ value, ...props }) {
  const selected = value ?? '';
  const listed = COUNTRY_OPTIONS.some(([code]) => code === selected);
  return (
    <select {...props} value={selected}>
      <option value="">Bitte Land auswählen</option>
      {selected && !listed && <option value={selected}>{selected}</option>}
      {COUNTRY_OPTIONS.map(([code, label]) => (
        <option key={code} value={code}>{label}</option>
      ))}
    </select>
  );
}

